import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { FirebaseProvider } from '../providers/Firebase';
import { captureCsatReturnUrlFromQuery } from '../services/legacyService';
import { EventType } from '../shared/enums';

export default function Welcome() {
  const navigate = useNavigate();
  const { session_id } = useParams();
  const [searchParams] = useSearchParams();

  const userId = searchParams.get("userId");
  const insuranceId = searchParams.get("insuranceId");

  const firebaseProvider = new FirebaseProvider();

  useEffect(() => {
    if (!session_id) return;

    // Persistir csatReturnUrl (se presente) ANTES das navegações internas, que
    // limpam a query string. Sobrevive até redirectToCSAT no fim da chamada.
    captureCsatReturnUrlFromQuery();

    // Salva metadata do usuário
    firebaseProvider.setUserMetadata(session_id, {
      identity: session_id,
      company: '',
      name: '',
      userId: userId ?? '',
      insuranceId: insuranceId ?? '',
    });

    // Envia evento de page view
    firebaseProvider.sendUserEvent(EventType.PAGE_VIEW, {
      page_location: '/home',
      page_encoding: '',
      page_title: 'Boas Vindas',
      user_agent: '',
      client_id: '',
      language: '',
      userId: userId ?? '',
      insuranceId: insuranceId ?? '',
    });

    // Redireciona automaticamente para a sala
    navigate('/room', { 
      state: { 
        sessionId: session_id, 
        userId, 
        insuranceId 
      } 
    });
  }, [session_id, userId, insuranceId, firebaseProvider, navigate]);

  // Não renderiza nada
  return null;
}